import {Http, Response, Headers, RequestOptionsArgs} from '@angular/http';
import { Observable } from "rxjs/Observable";
import {Injectable} from '@angular/core';
import 'rxjs/add/operator/map';
import {timeout} from 'rxjs/operators/timeout';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

@Injectable()
export class RestClientService {

  constructor(
    private http: Http,
    private spinnerService: Ng4LoadingSpinnerService) {
  }

  getResource<T>(resourcePath: string, extraHeaders?: { [key: string]: string }): Observable<Response>  {

      let headers = new Headers();
     //headers.append("Accept", "application/json");
     //headers.append('Cache-control', 'no-cache');
     //headers.append('Cache-control', 'no-store');
     //headers.append('Expires', '0');
     //headers.append('Pragma', 'no-cache');

      if (extraHeaders) {
        Object.keys(extraHeaders).forEach(key => headers.append(key, extraHeaders[key]));
      }

      let requestArgs: RequestOptionsArgs = {
        headers: headers
      };
      this.spinnerService.show();
		  return this.http.get(resourcePath, requestArgs);
   }

  getResourceTimeout<T>(resourcePath: string): Observable<Response>  {

    let headers = new Headers();
    headers.append("Accept", "application/json");
    headers.append('Cache-control', 'no-cache');
    headers.append('Cache-control', 'no-store');
    headers.append('Expires', '0');
    headers.append('Pragma', 'no-cache');

    let requestArgs: RequestOptionsArgs = {
      headers: headers
    };
    this.spinnerService.show();
    return this.http.get(resourcePath, requestArgs).pipe(timeout(15000));
  }

  postResource<T>(resourcePath: string, obj: T): Observable<any> {

      var json = JSON.stringify(obj);

      let headers = new Headers();
      headers.append("Content-Type", "application/json");
      let requestArgs: RequestOptionsArgs = {
        headers: headers
      };
      this.spinnerService.show();
      return this.http.post(resourcePath, json, requestArgs).map(response => response.json());

  }

  postResourceNoBody<T>(resourcePath: string): Observable<any> {

      let headers = new Headers();
      headers.append("Content-Type", "application/json");
      let requestArgs: RequestOptionsArgs = {
        headers: headers
      };
      this.spinnerService.show();
      return this.http.post(resourcePath, requestArgs).map(response => response.json());

  }

  putResource<T>(resourcePath: string, obj: T): Observable<T> {

      var json = JSON.stringify(obj);

      let headers = new Headers();
      headers.append("Content-Type", "application/json");
      let requestArgs: RequestOptionsArgs = {
        headers: headers
      };

      return this.http.put(resourcePath, json, requestArgs).map(response => response.json());

  }

  deleteResource(resourcePath: string): Observable<any> {

    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let requestArgs: RequestOptionsArgs = {
      headers: headers
    };
    
    this.spinnerService.show();
    return this.http.delete(resourcePath, requestArgs).map(response => response);
  }


}


// WEBPACK FOOTER //
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/services/restclient.service.ts